import type { ValueFormatterParams } from "ag-grid-community";
import { TagDisplay } from "~/components/domain/tags/TagDisplay";
import { Flex } from "~/ui";
import type { TagLabelMeta } from "../types/order-report.types";

export const TagsCellRenderer = (params: ValueFormatterParams<TagLabelMeta[] | string[]>) => {
  try {
    const raw = params?.value as TagLabelMeta[] | string[] | undefined;
    const values: TagLabelMeta[] = Array.isArray(raw) ? raw.map(v => (typeof v === "string" ? { label: v } : v)) : [];
    if (values.length === 0) {
      return null;
    }

    return (
      <Flex gap="xs" align="flex-start" direction="column" wrap="wrap">
        {values.map((t: TagLabelMeta, index: number) => (
          <TagDisplay key={`${t.label}-${index}`} label={t.label} color={t.color ?? undefined} icon={t.icon ?? undefined} size="sm" />
        ))}
      </Flex>
    );
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      // biome-ignore-start lint/suspicious/noConsole: carried over from the ESLint suppression
      console.error("TagsCellRenderer error:", error, { params });
      // biome-ignore-end lint/suspicious/noConsole: carried over from the ESLint suppression
    }
    return <span>Error rendering tags</span>;
  }
};
